import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { Link as LINKS } from "react-router-dom";
import Button from "components/CustomButtons/Button.jsx";
import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";
// import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import { connect } from "react-redux";

function HeaderLinks(props) {
  const { classes, close, token } = props;
  return (
    <List className={classes.list + " top-header"}>
      <ListItem className={classes.listItem + " listItemtop"}>
        <Button
          color="transparent"
          target="_blank"
          className={classes.navLink + " nalinktop"}
        >
          <LINKS to="/" className="linkmenua" onClick={close}>
            صفحه نخست
          </LINKS>
        </Button>
      </ListItem>
      {token ? (
        <>
          <ListItem className={classes.listItem + " listItemtop"}>
            <Button
              color="transparent"
              target="_blank"
              className={classes.navLink + " nalinktop"}
            >
              <LINKS to="/posts" className="linkmenua" onClick={close}>
                اطلاع رسانی قیمت
              </LINKS>
            </Button>
          </ListItem>
          <ListItem className={classes.listItem + " listItemtop"}>
            <Button
              color="transparent"
              target="_blank"
              className={classes.navLink + " nalinktop"}
            >
              <LINKS to="/market" className="linkmenua" onClick={close}>
                اطلاعات بازار
              </LINKS>
            </Button>
          </ListItem>
        </>
      ) : (
        ""
      )}

      <ListItem className={classes.listItem + " listItemtop"}>
        <Button
          color="transparent"
          target="_blank"
          className={classes.navLink + " nalinktop"}
        >
          <LINKS to="/Rouls" className="linkmenua" onClick={close}>
            قوانین و مقررات
          </LINKS>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem + " listItemtop"}>
        <Button
          color="transparent"
          target="_blank"
          className={classes.navLink + " nalinktop"}
        >
          <LINKS to="/AbouatUs" className="linkmenua" onClick={close}>
            درباره ما
          </LINKS>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem + " listItemtop"}>
        <Button
          color="transparent"
          target="_blank"
          className={classes.navLink + " nalinktop"}
        >
          <LINKS to="/ContactUs" className="linkmenua" onClick={close}>
            ارتباط با ما
          </LINKS>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem + " listItemtop"}>
        <Button color="transparent" className={classes.navLink + " nalinktop"}>
          <a
            className="linkmenua"
            href="http://t.me/joinchat/AAAAADwdoqvKCwf9HjSuLg"
          >
            کانال تلگرام
          </a>
        </Button>
      </ListItem>
      {/* <ListItem className={classes.listItem+" listItemtop"}>
        <CustomDropdown
          noLiPadding
          buttonText="سایر شبکه ها"
          buttonProps={{
            className: classes.navLink + ' dropdownmenu',
          }}

          dropdownList={[
            <Button color="transparent" className={classes.navLink+" nalinktop"}  >
              <a className='sociala' href='https://eitaa.com/ironScrap'>
                ایتا
            </a>
            </Button>,
            <a className='sociala' href='https://ble.im/ironScraps'>
              بله
            </a>,
            <a className='sociala' href='http://gap.im/ironScrap'>
              گپ
            </a>,
            <a className='sociala' href='http://sapp.ir/ironScrap'>
              سروش
            </a>
          ]}
        />
      </ListItem> */}
    </List>
  );
}

function mapStateToProps(state) {
  return { token: state.token };
}

// export default withStyles(headerLinksStyle)(HeaderLinks);

export default connect(
  mapStateToProps,
  null
)(withStyles(headerLinksStyle)(HeaderLinks));
